.container {
  display: flex;
  flex-direction: column;
  border: 1px solid #c7d8df;
  border-radius: var(--border-radius-xs);
  padding: 0 var(--space-s) var(--space-s);
  margin-bottom: var(--space-m);
  box-shadow: inset 0 0 4px 1px #eee, 0 0 2px 1px #eee;
}

.buttons {
  padding-top: var(--space-s);
  display: flex;
  justify-content: space-between;
}

.sortableList + .buttons {
  border-top: 1px solid #c7d8df;
}
